/**
 * settingsFactoryConsulting
 * @param _this
 * @param w24h
 */
window.settingsFactoryConsulting = function(_this, w24h = false) {
  _this.disabled = true;

  const payload = {
    status: _this.checked ? 100 : 1,
  };

  $.post(BASE_PATH + 'ajax/helper/betriebsdaten/settings.factoryConsulting?w24h=' + w24h, payload, function() {
    _this.disabled = false;
  });
};

/**
 * initialBetriebe: checkSelectedFactories
 * @param element
 */
window.initialBetriebe_checkSelectedFactories = function(element) {
  var hasCheckedFactories = false;
  var form = element.closest('form');
  var checkboxes = form.querySelectorAll('input[type="checkbox"]');

  if (checkboxes.length > 0) {
    checkboxes.forEach(function(checkbox) {
      if (checkbox.checked) {
        hasCheckedFactories = true;
      }
    });
  }

  var submitButton = document.getElementById('initial-betriebe-submit');
  if (hasCheckedFactories) {
    submitButton.removeAttribute('disabled');
  } else {
    submitButton.setAttribute('disabled', 'disabled');
  }
};